export default __webpack_public_path__ + "./image/edca4b1e865dbbf985b35e32822be831.png";